import { apiService } from "@/common/api.service.js";

export default {
  // EVA announcements
  evaAnnouncements() {
    const endpoint = `/api/eva-announcements/`;
    return apiService(endpoint);
  },

  // Start EVA session
  startEvaSession() {
    const endpoint = `/api/start-session/`;
    return apiService(endpoint, "POST");
  },

  // Start EVA opportunities session
  startEvaOpportunitiesSession() {
    const endpoint = `/api/start-session-opportunities/`;
    return apiService(endpoint, "POST");
  },

  // Ask EVA question
  askEvaQuestion(payload) {
    const endpoint = `/api/ask-question/${payload.sessionId}/`;
    return apiService(endpoint, "POST", payload);
  },
};
